<template>
    <div>
        <div style="text-align: center" class="p-grid">

            <div class=" p-col-12">
                <Button :disabled="disablePost" @click="transferGrade" :icon="'pi pi-step-backward'" style="height: auto"
                        label="העבר תלמידים"
                        class=" p-button-warning"></Button>
            </div>
            <div class="p-col-6">
                <select-grade v-model="gradeFromSelected" navigate-buttons useStore storage-name="gradeChanges-from"/>
                <div :key="pupilsList">
                    <h1>
                        {{ pupilsFromFiltered.length }} תלמידים
                    </h1>
                    <div v-for="(pupil, index) in pupilsFromFiltered">
                        <div v-if="index < 10">
                            {{ pupil.lastname }} {{ pupil.firstname }}
                        </div>
                    </div>
                    <div v-if=" pupilsFromFiltered.length >= 10">
                        ...
                    </div>
                </div>
            </div>
            <div class="p-col-6">
                <select-grade v-model="gradeToSelected" useStore storage-name="gradeChanges-to" :navigate-buttons="true"/>
                <div :key="pupilsList">
                    <h1>
                        {{ pupilsToFiltered.length }} תלמידים
                    </h1>
                    <div v-for="(pupil, index) in pupilsToFiltered">
                        <div v-if="index < 10">
                            {{ pupil.lastname }} {{ pupil.firstname }}
                        </div>
                    </div>
                    <div v-if=" pupilsToFiltered.length >= 10">
                        ...
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectGrade from "@/components/selects/SelectGrade";
import {mapActions, mapState} from "vuex";
import {transferGrades} from "@/components/gradeChanges/GradeChanges";
import {getGrade} from "@/utils/parseObj";

export default {
    name: "GradeChanges",
    components: {SelectGrade},
    data() {
        return {
            pupilsList: 0,
            gradeFromSelected: null,
            pupilsFrom: null,
            gradeToSelected: null,
            loading: false,
        }
    },
    computed: {
        ...mapState(["pupils"]),
        disablePost() {
            return this.loading
                || this.gradeFromSelected === null
                || this.gradeToSelected === null
                || this.gradeFromSelected === this.gradeToSelected
        },
        pupilsFromFiltered() {
            if (this.gradeFromSelected) {
                return this.pupils.filter(p =>
                    p.grade?.id === this.gradeFromSelected?.id
                )
            } else return []
        },
        pupilsToFiltered() {
            if (this.gradeToSelected?.id !== undefined) {

                return this.pupils.filter(p =>
                    p.grade?.id === this.gradeToSelected?.id
                )
            } else return []
        },

    },
    methods: {

        ...mapActions(["setPupils"]),
        async transferGrade() {
            this.loading = true
            try {
                const allPupils = await transferGrades(this.gradeFromSelected.id, this.gradeToSelected.id)
                const allPupilsExpended = allPupils.map(p => {
                    return {...p, grade: getGrade(p.grade)}
                })
                this.setPupils(allPupilsExpended)
            } catch (e) {
                this.openNotification("danger", `אופס`, `לא הצלחנו להעביר`);
            }
            this.loading = false
        },
        selectFrom(grade) {
            // this.gradeFromSelected = grade
            this.pupilsList++
            // this.pupilsFrom = this.pupilsFiltered(grade)
        },
        openNotification(color, title, text, position = "right-left", duration = 3000) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
        selectTo(grade) {
            // this.gradeToSelected = grade
            this.pupilsList++
        }
    },
}
</script>

<style scoped>

</style>